import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { gadgetSchema } from 'redux/gadget-read/gadget-read.adapter';
import { RootState } from 'redux/store';
import { LayoutResponse } from 'types/entity/layout-response';

export const layoutSchema = new schema.Entity(
  'layouts',
  { gadget: [gadgetSchema] },
  {
    idAttribute: (value: LayoutResponse) => value.layout_id || '',
  },
);

export const layoutsAdapter = createEntityAdapter<LayoutResponse>({
  selectId: (model) => model.layout_id || '',
});

export const {
  selectById: selectLayoutById,
  selectIds: selectLayoutIds,
  selectEntities: selectLayoutEntities,
  selectAll: selectAllLayouts,
  selectTotal: selectTotalLayouts,
} = layoutsAdapter.getSelectors<RootState>((state) => state.layoutRead);
